import React, {
    useState,
    useRef,
    useEffect,
    useCallback,
    useContext,
} from "react";
import {
    GoogleMap,
    LoadScript,
    StandaloneSearchBox,
    Marker,
    Polygon,
    InfoWindow
} from "@react-google-maps/api";
import { List, Card, Button, Input, Tabs, Select, Col, Row, DatePicker, TimePicker, Typography, Modal } from "antd";
import { CompassOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { PublicContext } from "../PublicContext";
import dayjs from 'dayjs';
import "../../styles/custom.css";
import "../../styles/Maps.css";

const styles = {
    input: "px-3 py-3 h-12 placeholder-indigo-500 w-full",
    h2: "py-4 text-3xl text-gray-600 font-normal text-left",
    map: "mt-6 rounded-md select-none overflow-hidden sm:w-1/2",
    mainDiv: "sm:flex justify-between -mt-6",
};

const containerStyle = {
    width: "100%",
    height: "78vh",
    // height: "100vh",
};

const libraries = ["places", "geometry"];

const options = {
    disableDefaultUI: true,
};

//COMPONENT
export default function LocationsMap() {
    const [loading, setLoading] = useState(true);
    const [map, setMap] = useState(null);
    const [pickupSearchBox, setPickupSearchBox] = useState(null);
    const [deliverySearchBox, setDeliverySearchBox] = useState(null);
    // const [stores, setStores] = useState([]);
    const { stores, setStores, deliveryOrPickUp, setDeliveryOrPickUp, storeHours } = useContext(PublicContext);
    const [storeList, setStoreList] = useState([]);
    const [activeMarker, setActiveMarker] = useState(0);
    const [isPickup, setIsPickup] = useState(false);
    const [deliverableStores, setDeliverableStores] = useState();

    const [deliveryArea, setDeliveryArea] = useState([]);
    const [storeDistance, setStoreDistance] = useState(15000);
    const [deliverable, setDeliverable] = useState(true);
    const [enteredFullAddress, setenteredFullAddress] = useState(true);
    const [storeLoaded, setStoreLoaded] = useState(false);
    const [showMapView, setShowMapView] = useState(false);
    const [pickupAddress, setPickupAddress] = useState("");
    const [deliveryAddress, setDeliveryAddress] = useState("");
    const [selectedStore, setSelectedStore] = useState(null);
    const [selectedStoreHour, setSelectedStoreHour] = useState(null);


    var mapDeliveryZones = require("../../data/DeliveryZone.json");
    var storeDeliveryAreaCoords = [];
    var storeLatLng = [];
    var addressGeocode = useRef({ lat: 44, lng: -80 });
    const [center, setCenter] = useState(addressGeocode.current);
    sessionStorage.setItem("scheduleDate", dayjs().format('MMM-DD'));
    sessionStorage.setItem("scheduleTime", "now");
    const DateComponent = () => {
        const [selectedDate, setSelectedDate] = useState(dayjs());


        const disabledDate = (current) => {
            return current < dayjs().startOf('day');
        };

        const onSelect = (date, dateString) => {
            //console.log(date);
            //console.log(date.format('MMM-DD'));
            //console.log(dateString);
            if (date.isBefore(dayjs())) {
                //console.log("ping");
                setSelectedDate(dayjs());
                sessionStorage.setItem("scheduleDate", dayjs().format('MMM-DD'));
                return;
            }
            //console.log(date);
            //console.log(date.format('MMM-DD'));
            //sessionStorage.setItem("scheduleDate", date);
            sessionStorage.setItem("scheduleDate", date.format('MMM-DD'));
            setSelectedDate(date);
        };

        return (
            <DatePicker
                onChange={onSelect}
                value={selectedDate}
                defaultValue={selectedDate}
                disabledDate={disabledDate}
            />

        );
    }

    const TimeComponent = () => {
        const [selectedTime, setSelectedTime] = useState(dayjs());

        const disabledHours = () => {
            const hours = [];
            const currentHour = dayjs().hour();
            // Disable hours before the current time
            for (let i = 0; i < currentHour; i++) {
                hours.push(i);
            }
            // Disable hours outside of the specified ranges
            for (let i = 0; i < 24; i++) {
                if ((i < 11 || i > 15) && (i < 16 || i > 21)) {
                    hours.push(i);
                }
            }
            for (let i = 0; i < 24; i++) {
                if ((i < 11 || i > 15) && (i < 16 || i > 21)) {
                    hours.push(i);
                }
            }
            return hours;
        };

        const disabledMinutes = (selectedHour) => {
            const minutes = [];
            const currentMinute = dayjs().minute();
            if (selectedHour === dayjs().hour()) {
                for (let i = currentMinute - 1; i >= 0; i--) {
                    minutes.push(i);
                }
            }
            return minutes;
        };

        const disabledTime = () => {
            return {
                disabledHours: disabledHours,
                disabledMinutes: disabledMinutes
            };
        };

        const onSelect = (time, timeString) => {
            console.log(time);
            console.log(time.format('hh:mm a'));
            console.log(timeString);
            if (time.isBefore(dayjs())) {
                console.log("ping");
                setSelectedTime(dayjs());
                sessionStorage.setItem("scheduleTime", dayjs().format('hh:mm a'));
                return;
            }

            sessionStorage.setItem("scheduleTime", time.format('hh:mm a'));
            setSelectedTime(time);
        };

        return (
            <TimePicker
                onChange={onSelect}
                disabledTime={disabledTime}
                format="h:mm a"
                value={selectedTime}
                minuteStep={15}
                use12Hours={true}
            />
            //disabledHours = { disabledHours }
            //disabledMinutes = { disabledMinutes }
        );
    };

    const [isStoreInfoModalOpen, setStoreInfoModalOpen] = useState(false);
    const showStoreInfoModal = () => {
        setStoreInfoModalOpen(true);
    };

    const handleStoreInfoModalCancel = () => {
        setStoreInfoModalOpen(false);
    };

    const handleMapViewClick = () => {
        setShowMapView(!showMapView);
    };

    var sortStores = useRef([]);
    //console.log(stores);
    for (let i = 1; i <= stores.length; i++) {
        processdeliveryArea(i);
        // let dz = processdeliveryArea(i);
        // deliveryArea.push(dz);
    }
    const checkGoogleInterval = useRef();

    const navigate = useNavigate();

    const divStyle = {
        background: `white`,
        //border: `1px solid #ccc`,
        padding: 15,
    };

    const onLoad = useCallback(function callback(map) {
        // const bounds = new window.google.maps.LatLngBounds();
        // map.fitBounds(bounds);
        setMap(map);
    }, []);

    const onUnmount = useCallback(function callback(map) {
        setMap(null);
    }, []);

    const onPickupSearchBoxLoad = useCallback((ref) => {
        setPickupSearchBox(ref);
    }, []);

    const onDeliverySearchBoxLoad = useCallback((ref) => {
        setDeliverySearchBox(ref);
    }, []);

    const onPickupPlacesChanged = useCallback(() => {
        //console.log("onPickupPlacesChanged deliveryOrPickUp " + deliveryOrPickUp);
        //console.log(sessionStorage.getItem("deliveryOrPickUp"));
        //console.log(pickupSearchBox);
        let enteredLocation = pickupSearchBox.getPlaces();
        let storeId = 1;
        let count = 0;
        //console.log(enteredLocation);
        //console.log(enteredLocation[0].formatted_address);

        //validateAddress(enteredLocation[0].formatted_address);
        sessionStorage.setItem("selectedAddress", JSON.stringify(enteredLocation));
        addressGeocode.current = {
            lat: enteredLocation[0].geometry.location.lat(),
            lng: enteredLocation[0].geometry.location.lng(),
        };
        sessionStorage.setItem(
            "selectedCoords",
            JSON.stringify(addressGeocode.current)
        );
        //console.log(addressGeocode.current);
        // console.log(storeDeliveryAreaCoords);

        //if delivery, check if in delivery zone
        //if pickup, find stores within distance and fit map with all stores within distance
        if (sessionStorage.getItem("deliveryOrPickUp") === "delivery") {
            setDeliveryAddress(enteredLocation[0].formatted_address)
            if (enteredLocation[0].types[0] === "street_address" || enteredLocation[0].types[0] === "premise" || enteredLocation[0].types[0] === "subpremise") {
                setenteredFullAddress(true);
                console.log("in delivery");
                var tempDelivertableStoreList = [];
                console.log(storeDeliveryAreaCoords);
                storeDeliveryAreaCoords.forEach((item) => {
                    const deliveryzone = new window.google.maps.Polygon({
                        paths: item.coordinates,
                    });

                    if (
                        window.google.maps.geometry.poly.containsLocation(
                            addressGeocode.current,
                            deliveryzone
                        )
                    ) {
                        // if true, zoom to store of delivery zone
                        console.log("true");
                        let tempStore = stores.find(store => store.storeId === storeId);
                        const isExisting = tempDelivertableStoreList.some(
                            (obj) => obj.storeId === tempStore.storeId
                        );
                        if (!isExisting) {
                            storeId = item.storeId;
                            //console.log(storeId);
                            count++;
                            let currentDistance =
                                window.google.maps.geometry.spherical.computeDistanceBetween(
                                    addressGeocode.current,
                                    {
                                        lat: tempStore.lat,
                                        lng: tempStore.lng,
                                    }
                                );

                            tempStore.distanceToCustomer = currentDistance;
                            tempDelivertableStoreList.push(tempStore);
                        }
                        // return true;
                    }
                    else {
                        //console.log("false");
                        // findClosest(addressGeocode.current);
                        // if false, zoom to closest store and display no delivery available
                        // let closestStore = findClosest(addressGeocode.current);
                        // center = {lat: stores[closestStore.storeId-1].lat, lng: stores[closestStore.storeId-1].lng};
                        // return false;
                    }
                });

                //if in deliveryzone, set store and navigate to store menu
                // if (count > 0) {
                //   // localStorage.setItem("selectedStore", storeId);
                //   // navigate(`/menu`);
                //   setDeliverable(true);
                // } else {
                //   setDeliverable(false);
                // }

                // check if address in delivery zone
                // if true, zoom to store of delivery zone
                // if false, zoom to closest store and display no delivery available
                // checkDeliveryZone();

                // if in deliveryzone, center to store
                // if not find closest store

                if (count > 0) {
                    console.log(tempDelivertableStoreList);
                    let store = stores.find(store => store.storeId === storeId);
                    setCenter({
                        lat: store.lat,
                        lng: store.lng,
                    });
                    selectStore("delivery", store.storeId, store.storeCode)
                    //setDeliverableStores(tempDelivertableStoreList);
                    setDeliverable(true);
                }
                else {
                    // findClosest(addressGeocode.current);
                    setDeliverable(false);
                }
            }
            else {
                setenteredFullAddress(false);
            }
        }
        else {
            setPickupAddress(enteredLocation[0].formatted_address)
            //console.log("in pickup");
            //console.log("findClosest");
            findClosest(addressGeocode.current);
            storeListCard(storeDistance);
        }
    }, [pickupSearchBox]);

    const onDeliveryPlacesChanged = useCallback(() => {
        //console.log("onDeliveryPlacesChanged deliveryOrPickUp " + deliveryOrPickUp);
        //console.log(sessionStorage.getItem("deliveryOrPickUp"));
        //console.log(deliverySearchBox);
        let enteredLocation = deliverySearchBox.getPlaces();
        let storeId = 1;
        let count = 0;
        //console.log(enteredLocation);
        //console.log(enteredLocation[0].formatted_address);

        //validateAddress(enteredLocation[0].formatted_address);
        sessionStorage.setItem("selectedAddress", JSON.stringify(enteredLocation));
        addressGeocode.current = {
            lat: enteredLocation[0].geometry.location.lat(),
            lng: enteredLocation[0].geometry.location.lng(),
        };
        sessionStorage.setItem(
            "selectedCoords",
            JSON.stringify(addressGeocode.current)
        );
        //console.log(addressGeocode.current);
        // console.log(storeDeliveryAreaCoords);

        //if delivery, check if in delivery zone
        //if pickup, find stores within distance and fit map with all stores within distance
        if (sessionStorage.getItem("deliveryOrPickUp") === "delivery") {
            setDeliveryAddress(enteredLocation[0].formatted_address)
            if (enteredLocation[0].types[0] === "street_address" || enteredLocation[0].types[0] === "premise" || enteredLocation[0].types[0] === "subpremise") {
                setenteredFullAddress(true);
                //console.log("in delivery");
                var tempDelivertableStoreList = [];
                //console.log(storeDeliveryAreaCoords);
                storeDeliveryAreaCoords.forEach((deliveryCoords) => {
                    //console.log(deliveryCoords);
                    const deliveryzone = new window.google.maps.Polygon({
                        paths: deliveryCoords.coordinates,
                    });

                    if (
                        window.google.maps.geometry.poly.containsLocation(
                            addressGeocode.current,
                            deliveryzone
                        )
                    ) {
                        // if true, zoom to store of delivery zone
                        //console.log("true " + storeId);
                        let tempStore = stores.find(store => store.storeId === storeId);
                        const isExisting = tempDelivertableStoreList.some(
                            (obj) => obj.storeId === tempStore.storeId
                        );
                        if (!isExisting) {
                            storeId = deliveryCoords.storeId;
                            //console.log(storeId);
                            //console.log(tempStore);
                            count++;
                            let currentDistance =
                                window.google.maps.geometry.spherical.computeDistanceBetween(
                                    addressGeocode.current,
                                    {
                                        lat: tempStore.lat,
                                        lng: tempStore.lng,
                                    }
                                );

                            tempStore.distanceToCustomer = currentDistance;
                            tempDelivertableStoreList.push(tempStore);
                        }
                        // return true;
                    }
                    else {
                        //console.log("false");
                        // findClosest(addressGeocode.current);
                        // if false, zoom to closest store and display no delivery available
                        // let closestStore = findClosest(addressGeocode.current);
                        // center = {lat: stores[closestStore.storeId-1].lat, lng: stores[closestStore.storeId-1].lng};
                        // return false;
                    }
                });

                //if in deliveryzone, set store and navigate to store menu
                // if (count > 0) {
                //   // localStorage.setItem("selectedStore", storeId);
                //   // navigate(`/menu`);
                //   setDeliverable(true);
                // } else {
                //   setDeliverable(false);
                // }

                // check if address in delivery zone
                // if true, zoom to store of delivery zone
                // if false, zoom to closest store and display no delivery available
                // checkDeliveryZone();

                // if in deliveryzone, center to store
                // if not find closest store

                if (count > 0) {
                    //console.log(tempDelivertableStoreList);
                    let store = stores.find(store => store.storeId === storeId);
                    setCenter({
                        lat: store.lat,
                        lng: store.lng,
                    });
                    selectStore("delivery", store.storeId, store.storeCode)
                    //setDeliverableStores(tempDelivertableStoreList);
                    setDeliverable(true);
                }
                else {
                    // findClosest(addressGeocode.current);
                    setDeliverable(false);
                }
            }
            else {
                setenteredFullAddress(false);
            }
        }
        else {
            setPickupAddress(enteredLocation[0].formatted_address)
            //console.log("in pickup");
            //console.log("findClosest");
            findClosest(addressGeocode.current);
            storeListCard(storeDistance);
        }
    }, [deliverySearchBox]);

    const onTabChange = (key) => {
        //console.log(key);
        if (key === "delivery") {
            setIsPickup(false);
        } else {
            setIsPickup(true);
        }
        sessionStorage.setItem("deliveryOrPickUp", key);
        setDeliveryOrPickUp(key);
    };

    const handleDistanceChange = (value) => {
        //console.log("selected value " + value);
        // setNumStoreInDistance(0);
        storeListCard(value);
        setStoreDistance(value);
    };

    const tabItems = [
        {
            key: "delivery",
            label: "Delivery",
            children: deliveryTab(),
        },
        {
            key: "pickup",
            label: "Pickup",
            children: pickupTab(),
        },
    ];

    useEffect(() => {
        //console.log("empty useeffect");
        //window.location.href = 'https://www.mandarinrestaurant.com/order-online/';
        populateStoreData();
        if (deliveryOrPickUp === "delivery") {
            setIsPickup(false);
        } else {
            setIsPickup(true);
        }
        // checkGoogleInterval.current = setInterval(checkGoogleLoaded, 100);
        // return () => {
        //   clearInterval(checkGoogleInterval.current);
        // };
    }, []);

    useEffect(() => {
        //console.log("stores useeffect: " + stores.length);
        if (stores.length > 0) {
            checkGoogleInterval.current = setInterval(checkGoogleLoaded, 100);
            return () => {
                clearInterval(checkGoogleInterval.current);
            };
        }
    }, [storeLoaded]);

    function checkGoogleLoaded() {
        //console.log("check google");
        if (window.google) {
            //console.log("in check google");
            clearInterval(checkGoogleInterval.current);
            let stores = JSON.parse(localStorage.getItem("stores"));
            // setCheckGoogle(true);
            // if (checkGoogle) {
            // if (window.google) {
            // console.log(stores);
            //console.log("Check google " + stores.length);
            if (stores.length !== 0) {
                // console.log("Check google if");
                if (
                    navigator.geolocation &&
                    sessionStorage.getItem("selectedCoords") == null
                ) {
                    // if (navigator.geolocation) {
                    navigatorDirection(stores);
                } else if (sessionStorage.getItem("selectedCoords") !== null) {
                    //console.log("navigator no location");
                    let inDeliveryZone = false;
                    stores.forEach((store, index) => {
                        inDeliveryZone = checkDeliveryZone(index + 1);
                    });
                    if (inDeliveryZone.response) {
                        let storeId = inDeliveryZone.storeId;
                        let store = stores.find(store => store.storeId === storeId);
                        setCenter({
                            lat: store.lat,
                            lng: store.lng,
                        });
                    } else {
                        // findClosest(addressGeocode.current);
                        //console.log("findClosest");
                        findClosest(JSON.parse(sessionStorage.getItem("selectedCoords")));
                    }
                    storeListCard(storeDistance);
                }
            }
            // }
        }
    }

    function navigatorDirection() {
        navigator.geolocation.getCurrentPosition((position) => {
            //console.log(position);
            // setCenter({
            //   lat: position.coords.latitude,
            //   lng: position.coords.longitude,
            // });
            addressGeocode.current = {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
            };

            //console.log("addressGeocode.current: " + addressGeocode.current);

            sessionStorage.setItem(
                "selectedCoords",
                JSON.stringify(addressGeocode.current)
            );
            //console.log("navigator set location");
            let inDeliveryZone = false;
            stores.forEach((store, index) => {
                inDeliveryZone = checkDeliveryZone(index + 1);
            });
            if (inDeliveryZone.response) {
                // setCenter(stores)
                let storeId = inDeliveryZone.storeId;
                let store = stores.find(store => store.storeId === storeId);
                setCenter({
                    lat: store.lat,
                    lng: store.lng,
                });
            } else {
                //console.log("findClosest");
                findClosest(addressGeocode.current);
            }
            storeListCard(storeDistance);
            // console.log(center);
        });
    }

    async function addDZtoStore(stores) {
        //console.log("Start updaet DZ");
        //console.log(stores);
        stores.forEach((store, index) => {
            let myarray = mapDeliveryZones.filter(
                (item) => item.storeID == store.storeId
            );
            //console.log(store.storeId);
            //console.log(myarray);
            if (myarray.length == 0) {
                return null;
            }

            //console.log(storedeliveryArea)

            store.deliveryZones = JSON.stringify(myarray);

            //console.log("After add dz,mystore :")
            //console.log(store);
            //console.log(store.deliveryZones);

            const response = fetch("api/stores/" + store.storeId, {
                method: "PUT",
                body: JSON.stringify(store), // string or object
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            })
                .then(() => (response) => response.json())
                .catch((error) => console.error("Unable to update item.", error));
            // const myJson = await response.json(); //extract JSON from the http response
            // console.log("Put Result")
            // console.log(myJson)
        });
    }

    async function populateStoreData() {
        // console.log(process.env);
        // console.log("Start Downloading stores");
        // const response = await fetch("api/Stores");
        // const data = await response.json();
        // console.log(data.length + " stores loaded");
        // console.log(data);
        // setStores(data);
        // localStorage.setItem("storeList", JSON.stringify(data));
        //console.log("populate stores");
        setStores(JSON.parse(localStorage.getItem("stores")));
        setStoreLoaded(JSON.parse(localStorage.getItem("stores")));
        if (sessionStorage.getItem("deliveryOrPickUp")) {
            setDeliveryOrPickUp(sessionStorage.getItem("deliveryOrPickUp"));
        }
        else {
            sessionStorage.setItem("deliveryOrPickUp", "delivery");
        }
        // console.log(deliveryOrPickUp);
        //addDZtoStore(data)
        setLoading(false);
    }

    function processdeliveryArea(id) {
        //let myarray=mapDeliveryZones.filter((item)=>item.storeID===id)
        //console.log("processdeliveryArea " + id);
        let myarray = stores.filter((item) => item.storeId === id);
        //console.log(myarray);
        if (myarray.length === 0) {
            return null;
        }
        let storedeliveryArea = myarray[0];
        //console.log( "delivery zones for:" + id )
        //console.log(storedeliveryArea)
        // console.log(storedeliveryArea)
        if (!storedeliveryArea.deliveryZones) {
            return null;
        }
        let polygons = JSON.parse(storedeliveryArea.deliveryZones);

        //console.log("Json")
        //console.log(polygons)

        /* polygons.map((p) => { DeliveryAreaArray.push(p) })*/

        //console.log(polygons)
        const mycolor = [
            "cyan",
            "lightblue",
            "Orange",
            "RoyalBlue",
            "lightgrey",
            "LightSalmon",
            "lightgreen",
            "PeachPuff",
            "Brown",
            "lightpink",
        ];
        let colorindex = id % 10;
        let thiscolor = mycolor[colorindex];

        const myoptions = {
            fillColor: thiscolor,
            fillOpacity: 0.6,
            strokeColor: "red",
            strokeOpacity: 1,
            strokeWeight: 1,
            clickable: false,
            draggable: false,
            editable: false,
            geodesic: true,
            zIndex: 1,
        };

        let polygonsMap = polygons.map((polygon) => {
            // console.log(polygon);
            let mypaths = polygon.coordinates.map((point) => {
                return { lat: point[1], lng: point[0] };
            });
            //console.log("path")
            // console.log(mypaths)

            storeDeliveryAreaCoords.push({
                coordinates: mypaths,
                storeId: polygon.storeID,
                desc: polygon.name,
            });
            // console.log(storeDeliveryAreaCoords);

            storeLatLng.push({
                lat: storedeliveryArea.lat,
                lng: storedeliveryArea.lng,
            });

            return (
                <Polygon
                    paths={mypaths}
                    options={myoptions}
                    key={polygon.storeID + polygon.coordinates}
                />
            );
        });
        //console.log("Set Store Area:" + id +" "+stores[id-1].storeName)
        //console.log("color:" + thiscolor)
        //console.log(polygonArray)
        //console.log(polygons)
        return polygonsMap;
    }

    function handleActiveMarker(storeId) {
        //console.log("active marker " + storeId);
        setActiveMarker(storeId);
    }

    function StoreInfo(store, storeHour) {
        var dayOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
        var today = dayjs().format('dddd');
        return (
            <div style={divStyle}>
                <h4>{store.storeName} Location</h4>
                <Row>
                    <Col span={6} className="p-1">Address</Col>
                    <Col span={9} className="p-1">{store.storeAddress}</Col>
                </Row>
                <Row>
                    <Col span={6} className="p-1">Phone</Col>
                    <Col span={9} className="p-1">{store.storePhone}</Col>
                </Row>
                <hr></hr>
                <Row>
                    <Col span={6} className="p-1"></Col>
                    <Col span={9} className="p-1">Delivery</Col>
                    <Col span={9} className="p-1">Pickup</Col>
                </Row>

                {dayOfWeek.map(day => {
                    var startTimeD = dayjs(storeHour.filter(sh => sh.classification === "Delivery" && sh.day === day)[0].startTime).format("hh:mm a");
                    var endTimeD = dayjs(storeHour.filter(sh => sh.classification === "Delivery" && sh.day === day)[0].endTime).format("hh:mm a");
                    var startTimeP = dayjs(storeHour.filter(sh => sh.classification === "Pickup" && sh.day === day)[0].startTime).format("hh:mm a");
                    var endTimeP = dayjs(storeHour.filter(sh => sh.classification === "Pickup" && sh.day === day)[0].endTime).format("hh:mm a");
                    if (day === today) {
                        return (
                            <Row key={"storeMarker" + store.storeId + "hour" + day}>
                                <Col span={6} className="p-1"><b>{day}</b></Col>
                                <Col span={9} className="p-1"><b>{startTimeD}-{endTimeD}</b></Col>
                                <Col span={9} className="p-1"><b>{startTimeP}-{endTimeP}</b></Col>
                            </Row>
                        )
                    }
                    else {
                        return (
                            <Row key={"storeMarker" + store.storeId + "hour" + day}>
                                <Col span={6} className="p-1">{day}</Col>
                                <Col span={9} className="p-1">{startTimeD}-{endTimeD}</Col>
                                <Col span={9} className="p-1">{startTimeP}-{endTimeP}</Col>
                            </Row>
                        )
                    }

                })}
            </div >
        )
    }

    function StoreMarkers() {
        return storeList.map((store) => {
            var storeHour = storeHours.filter(sh => sh.storeCode === store.storeCode);
            return (
                <Marker
                    position={{ lat: store.lat, lng: store.lng }}
                    title={"Mandarin " + store.storeName + "\n Phone:" + store.storePhone}
                    key={"storeMarker" + store.storeId}
                    onClick={() => handleActiveMarker(store.storeId)}
                >
                    {activeMarker === store.storeId && (
                        <InfoWindow
                            position={{ lat: store.lat, lng: store.lng }}
                            onCloseClick={() => {
                                setActiveMarker(0);
                            }}
                        >
                            <div>
                                {StoreInfo(store, storeHour)}

                                <Button
                                    className="btn-primary"
                                    onClick={() =>
                                        selectStore("pickup", store.storeId, store.storeCode)
                                    }
                                >
                                    Pickup at this store
                                </Button>
                            </div>
                        </InfoWindow>
                    )}
                </Marker>
            )
        });
    }

    function StoreInfoModal() {
        return (
            <Modal
                open={isStoreInfoModalOpen}
                onCancel={handleStoreInfoModalCancel}
                footer={null}
            >
                {(selectedStore != null && selectedStoreHour != null) && StoreInfo(selectedStore, selectedStoreHour)}
            </Modal>
        )
    }

    function checkDeliveryZone(storeId) {
        // console.log(storeId);
        // console.log(storeDeliveryAreaCoords[storeId]);
        let count = 0;
        let deliveryStoreId = 0;
        storeDeliveryAreaCoords
            .filter((coords) => coords.storeId === storeId)
            .forEach((filteredCoords) => {
                const deliveryzone = new window.google.maps.Polygon({
                    paths: filteredCoords.coordinates,
                });
                // console.log(addressGeocode.current);
                // console.log(deliveryzone);

                if (
                    window.google.maps.geometry.poly.containsLocation(
                        addressGeocode.current,
                        deliveryzone
                    )
                ) {
                    // console.log("true");
                    // console.log(filteredCoords)
                    // return true;
                    count++;
                    deliveryStoreId = storeId;
                } else {
                    // console.log("false");
                    // console.log(filteredCoords);
                    // return false;
                }
            });

        if (count > 0) {
            return { storeId: deliveryStoreId, response: true };
        } else return { response: false };
    }

    function findClosest(location) {
        //console.log("find closest");
        // console.log(location);
        let closestId = 0;
        let closestDistance = 99999999;
        //console.log(location);

        //console.log(stores);
        if (stores.length === 0) {
            return;
        }
        let tempStores = stores;
        stores.forEach(async (store, index) => {
            let currentDistance =
                window.google.maps.geometry.spherical.computeDistanceBetween(location, {
                    lat: store.lat,
                    lng: store.lng,
                });

            tempStores[index].distanceToCustomer = currentDistance;

            // tempStoreDistanceArray[index] = currentDistance;

            if (currentDistance < closestDistance) {
                closestDistance = currentDistance;
                closestId = index;
                //console.log(index);
                //console.log(store);
            }
        });

        sortStores.current = []
            .concat(tempStores)
            .sort((a, b) => (a.distanceToCustomer > b.distanceToCustomer ? 1 : -1));

        // setStores(sortStores);
        // console.log(stores);

        // setStoreDistanceArray(tempStoreDistanceArray);

        // storeLatLng
        // only 25 destinations at a time

        // await distanceService
        //   .getDistanceMatrix({
        //     origins: [location],
        //     destinations: storeLatLng,
        //     travelMode: "DRIVING",
        //   })
        //   .then((response) => {
        //     console.log("DMS response");
        //     console.log(response);
        //     // console.log(response.rows[0].elements[0].distance.value);
        //     // let currentDistance = response.rows[0].elements[0].distance.value;
        //     // if (currentDistance < closestDistance) {
        //     //   console.log("in if");
        //     //   closestDistance = currentDistance;
        //     //   closestId = index;
        //     // }
        //   });

        // setCenter({
        //   lat: stores[closestId].lat,
        //   lng: stores[closestId].lng,
        // });

        setCenter({
            lat: location.lat,
            lng: location.lng,
        });

        return { storeId: closestId, distance: closestDistance };
    }

    function getClosestGeocode(location) {
        //console.log(stores);
        if (stores.length === 0) {
            return;
        }
        let store = stores.find(store => store.storeId === location.storeId);
        //console.log(store);
        return {
            lat: store.lat,
            lng: store.lng,
        };
    }

    function deliveryTab() {
        return (
            <>
                <StandaloneSearchBox
                    onLoad={onDeliverySearchBoxLoad}
                    onPlacesChanged={onDeliveryPlacesChanged}
                >
                    <Input
                        type="text"
                        name="address"
                        placeholder="Enter Your Address"
                        autoComplete="on"
                        value={deliveryAddress}
                        onChange={e => setDeliveryAddress(e.target.value)}
                        className={styles.input}
                    ></Input>
                </StandaloneSearchBox>

                {!enteredFullAddress &&
                    <div>
                        <p>Please enter your full delivery address.</p>
                    </div>
                }

                {!deliverable &&
                    <div>
                        <p>Sorry, you are not within our deliverable area.</p>
                        <p>Would you like to do a pick up order instead?</p>
                    </div>
                }
            </>
        );
    }

    function pickupTab() {
        return (
            <>
                <StandaloneSearchBox
                    onLoad={onPickupSearchBoxLoad}
                    onPlacesChanged={onPickupPlacesChanged}
                >
                    <Input
                        type="text"
                        name="address"
                        placeholder="Address or Postal Code"
                        autoComplete="on"
                        value={pickupAddress}
                        onChange={e => setPickupAddress(e.target.value)}
                        className={styles.input}
                    />
                </StandaloneSearchBox>
                <Button
                    className="btn-primary-outline btn-outline"
                    style={{
                        height: "42px", marginTop: "8px", marginBottom: "8px", fontSize: "16px", display: "flex", alignItems: "center"
                    }}
                    shape="round"
                    icon={<CompassOutlined style={{ fontSize: "26px" }} />}
                    onClick={() => navigatorDirection()}
                >
                    Auto Locate
                </Button>
                <div>
                    Showing {storeList.length} store
                    {storeList.length > 1 ? <>s</> : <></>} within{" "}
                    <Select
                        defaultValue={15000}
                        style={{ width: 80 }}
                        onChange={handleDistanceChange}
                        options={[
                            { value: 1000, label: "1 km" },
                            { value: 5000, label: "5 km" },
                            { value: 10000, label: "10 km" },
                            { value: 15000, label: "15 km" },
                            { value: 25000, label: "25 km" },
                            { value: 50000, label: "50 km" },
                            { value: 100000, label: "100 km" },
                        ]}
                    />{" "}
                    of your location.
                </div>

                <List
                    dataSource={storeList}
                    className="storeList"
                    renderItem={(item, index) => (
                        <Card
                            hoverable
                            className="address-card"
                            onClick={() => {
                                if (showMapView) {
                                    handleActiveMarker(item.storeId)
                                }
                                else {
                                    console.log("click card");
                                    //if (selectedStore != null && selectedStoreHour != null) {
                                    var storeHour = storeHours.filter(sh => sh.storeCode === item.storeCode);
                                    setSelectedStore(item);
                                    setSelectedStoreHour(storeHour);
                                    showStoreInfoModal();
                                    //}
                                }
                            }}
                        >
                            <Typography.Title level={4}>{item.storeName}</Typography.Title>
                            <Typography>{(item.distanceToCustomer / 1000).toFixed(0)} km</Typography>
                            <Typography>{item.storeAddress}</Typography>
                            {/*<Typography>Hours</Typography>*/}
                            {/* <p>{item.storePhone}</p> */}
                            {/* <p>{item.storeEmail}</p> */}
                            <Button
                                className="btn-primary"
                                onClick={() =>
                                    selectStore("pickup", item.storeId, item.storeCode)
                                }
                            >
                                Pickup at this store
                            </Button>
                        </Card>
                    )}
                // renderItem={storeListCard(stores)}
                />
                {/* </>
        )} */}
            </>
        );
    }

    function storeListCard(distance) {
        let tempList = [];
        //console.log("in storelist " + distance);
        let LatLngList = [];
        sortStores.current.forEach((item, index) => {
            if (item.distanceToCustomer <= distance) {
                tempList.push(item);
                LatLngList.push(new window.google.maps.LatLng(item.lat, item.lng));
            }
        });
        // console.log(tempList);
        if (tempList.length > 0) {
            if (window.google) {
                var bounds = new window.google.maps.LatLngBounds();
                for (var i = 0, LtLgLen = LatLngList.length; i < LtLgLen; i++) {
                    bounds.extend(LatLngList[i]);
                }
                if (map) {
                    map.fitBounds(bounds);
                    setMap(map);
                }
            }
        }
        setStoreList(tempList);
    }

    function selectStore(selector, storeId, storeCode) {
        sessionStorage.setItem(
            "selectedStore",
            JSON.stringify({ storeId: storeId, storeCode: storeCode })
        );
        sessionStorage.setItem("deliveryOrPickUp", selector);
        if (selector === "pickup") {
            navigate(`/menu?storeId=` + storeId + `&storeCode=` + storeCode);
        } else {
            // check delivery zone
            if (checkDeliveryZone(storeId).response) {
                //console.log("address is in delivery zone");
                navigate(`/menu?storeId=` + storeId + `&storeCode=` + storeCode);
            } else {
                //console.log("address not in delivery zone");
                //console.log("findClosest");
                //console.log(findClosest(addressGeocode.current));
            }
        }
    }

    return (
      //googleMapsApiKey = "AIzaSyDMag6mcpti-LqIRnknTGYqIAq5quT_Z7U" - prod
      //googleMapsApiKey = "AIzaSyB8PS9NYRcIupRnc8XzEFI_C3ALTyzJ4FQ" - dev
      <>
        {loading ? (
          <>Loading</>
        ) : (
          <div className="sm:flex justify-between -mt-6 location-main-div">
            <LoadScript
              googleMapsApiKey="AIzaSyDMag6mcpti-LqIRnknTGYqIAq5quT_Z7U"
              libraries={libraries}
              language="en"
              region="us"
            >
              <Row>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: showMapView ? 12 : 24 }}
                  lg={{ span: showMapView ? 10 : 24 }}
                  className="addressTabsCol"
                >
                  <div className="addressTabsDiv">
                    {/*<div style={{ marginBottom: "20px" }}>*/}
                    {/*    <Typography.Title level={4}>Order Schedule</Typography.Title>*/}
                    {/*    <Row style={{ marginBottom: "10px" }}>*/}
                    {/*        <Col flex="50px">*/}
                    {/*            <Typography.Title level={5}>Date:</Typography.Title>*/}
                    {/*        </Col>*/}
                    {/*        <Col flex="auto">*/}
                    {/*            <DateComponent />*/}
                    {/*        </Col>*/}
                    {/*    </Row>*/}
                    {/*    <Row style={{ marginBottom: "10px" }}>*/}
                    {/*        <Col flex="50px">*/}
                    {/*            <Typography.Title level={5}>Time:</Typography.Title>*/}
                    {/*        </Col>*/}
                    {/*        <Col flex="auto">*/}
                    {/*            <TimeComponent />*/}
                    {/*        </Col>*/}
                    {/*    </Row>*/}
                    {/*</div>*/}
                    <div>
                      <Button
                        className="btn-tertiary-outline btn-outline showMapBtn"
                        shape="round"
                        onClick={handleMapViewClick}
                      >
                        Map View
                      </Button>
                      <Tabs
                        defaultActiveKey={deliveryOrPickUp}
                        items={tabItems}
                        onChange={onTabChange}
                        className="addressTabs"
                      />
                    </div>
                  </div>
                </Col>

                {showMapView && (
                  <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: showMapView ? 12 : 24 }}
                    lg={{ span: showMapView ? 14 : 24 }}
                    className={styles.map}
                  >
                    <GoogleMap
                      id="googlemap"
                      mapContainerStyle={containerStyle}
                      center={center}
                      zoom={10}
                      onLoad={onLoad}
                      onUnmount={onUnmount}
                    >
                      <Marker
                        position={center}
                        icon={{
                          url: "https://maps.google.com/mapfiles/ms/icons/blue-dot.png",
                        }}
                        title="Me"
                      />
                      {isPickup && <StoreMarkers />}
                      {deliveryArea}
                    </GoogleMap>
                  </Col>
                )}
              </Row>
            </LoadScript>
            <StoreInfoModal></StoreInfoModal>
          </div>
        )}
      </>
    );
}


